module.exports = __webpack_public_path__ + "img/klarna-data.8dcc8fc3.svg";